import React from 'react';
import Widgets from '../Widgets';
import { LegendNumeric, StackedGraph, InfoBlock, CustomFilter } from '../../../components';
import { isEqual } from 'lodash';
import './WidgetChartNumeric.css';

export default class WidgetChartNumeric extends Widgets {
  componentDidUpdate(props, state) {
    if (
      (!isEqual(this.props.filters, props.filters) || ((this.state && state) && !isEqual(this.state.extraFilters, state.extraFilters)) || this.props.shouldLoadData)
      && (this.props.filtersLoaded)
    ){
      return this.props.fetchData({
        ...this.props.filters,
        ...(this.state ? this.state.extraFilters : {})
      }, this.props.id)
    }
  }

  onCustomFilterChange = (items) => {
    const extraFilters = items.reduce((acc, curr) => ({
      ...acc,
      ...(curr.value.split('=').length === 2 ? {[curr.value.split('=')[0]]: curr.value.split('=')[1]} : {})
    }), {});
    this.setState({ extraFilters, selectedFilters: items.filter(item => item.value.split('=').length === 2) });
  }

  render() {
    if (this.props.loaded)
      return (
        <div className={this.props.className ? `${this.props.className} WidgetChartNumeric` : 'WidgetChartNumeric'} style={this.props.style}>
          <h1 className="title">{this.props.title}</h1><span className="actions">{this.props.onZoom ? <a onClick={this.props.onZoom}><i className="fa fa-search"></i></a> : null}<a onClick={this.downloadDataAsCSV}><i className="fa fa-download"></i></a></span>
          {this.props.customFilter ? <CustomFilter className="CustomFilter" selected={this.state && this.state.selectedFilters ? this.state.selectedFilters : []} onChange={this.onCustomFilterChange} /> : null}
          <div style={{'width': '90%', 'float': 'left'}}>
            {this.props.graph && this.props.graph.length ? <LegendNumeric colorScheme={this.props.colorScheme} keys={Object.keys(this.props.graph[0]).filter(item => item !== 'cat')} size={[this.props.width * 0.9, 50]} className="widget-stack-legend" /> : null}
            <br />
            <StackedGraph
              colorScheme={this.props.colorScheme}
              data={this.props.graph ? this.props.graph : []}
              size={[this.props.info && this.props.info.length ? this.props.width * 0.8 : this.props.width * 0.95, this.props.height * 0.7]}
              filters={{
                ...this.props.filters,
                ...(this.state ? this.state.extraFilters : {})
              }}
              {...(this.props.drillOptions ? { drillOptions: this.props.drillOptions } : {})}
              {...(this.props.drillData ? { drillData: this.props.drillData } : {})}
            />
          </div>
          <div className="infoBlocks" style={{'width': this.props.width * 0.15}}>
            {this.props.info.map((item, idx) => (
              <div>
                {idx !== 0 ? <hr /> : null}
                <InfoBlock {...item} />
              </div>
            ))}
          </div>
        </div>
      );
    else if (!this.props.loaded && this.props.filtersLoaded)
      return (
        <div className={this.props.className ? `${this.props.className} WidgetChartNumeric` : 'WidgetChartNumeric'} style={this.props.style}>
          <img src={`${process.env.PUBLIC_URL}/loading.svg`} />
        </div>
      );
    else
      return (
        <div className={this.props.className ? `${this.props.className} WidgetChartNumeric` : 'WidgetChartNumeric'} style={this.props.style}>
          <h1>select operator and service to see stats</h1>
        </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/Widgets/WidgetChartNumericComponent/WidgetChartNumeric.js